var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"has-text-centered"},[_vm._v(_vm._s(_vm.reason.id))]),_c('td',{staticClass:"has-text-centered"},[_vm._v(" "+_vm._s(_vm.reason.title)+" ")]),_c('td',{staticClass:"has-text-centered"},[_c('router-link',{staticClass:"button is-small",attrs:{"to":{
        name: 'settings.cancelOrderReasons.edit',
        params: { uuid: _vm.reason.uuid },
      }}},[_c('span',{staticClass:"icon is-small"},[_c('span',{staticClass:"fa fa-fw fa-pencil"})])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }